var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pictogram-row"},[_vm._l((_vm.firstThreePictograms),function(pictogram){return _c('div',{key:pictogram,staticClass:"pictogram"},[_c('pictogram',{attrs:{"image-path":pictogram,"show-text":false}})],1)}),(_vm.hasMoreThanThreePictograms)?_c('div',[_vm._v(" (+"+_vm._s(_vm.item.pictograms.length - 3)+") ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }